var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.wrapper
  }, [_c('h2', {
    class: _vm.$style.heading
  }, [_vm._v("\n      Забыли пароль?\n    ")]), _vm._v(" "), _c('p', {
    class: _vm.$style.message
  }, [_vm._v("\n      Укажите электронную почту, которую использовали при регистрации, на неё\n      мы отправим инструкции по сбросу пароля.\n    ")]), _vm._v(" "), _c('VForm', {
    class: _vm.$style.formContainer
  }, [_c('FormFieldEmail', {
    attrs: {
      "label": "E-mail",
      "field": "email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.wrapperControls
  }, [_c('SButton', {
    attrs: {
      "theme": "secondary"
    },
    on: {
      "click": _vm.backToChangePassword
    }
  }, [_vm._v("\n      Отменить\n    ")]), _vm._v(" "), _c('SButton', {
    attrs: {
      "theme": "primary",
      "loading": _vm.loader
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v("\n      Продолжить\n    ")])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };